/* GENERATED by apps/web-shared/scripts/fetch-fonts.mjs — do not edit. */
export const FONT_PRELOAD = [
  "/fonts/instrument-sans-latin-2ee17598.woff2",
  "/fonts/jetbrains-mono-latin-83c005d4.woff2",
  "/fonts/martian-mono-latin-f9c1655c.woff2"
];
